const accessToAll = [
  'Chief',
  'Admin',
  'Viewer',
  'PolyurethaneAdmin',
  'PolyurethaneChief',
  'PolyurethaneViewer',
  'PolyurethaneSupervisor',
];
type PolyurethaneRoles =
  | 'PolyurethaneAdmin'
  | 'PolyurethaneChief'
  | 'PolyurethaneViewer'
  | 'PolyurethaneSupervisor'
  | 'PolyurethaneLeader'
  | 'PolyurethaneLeaderMachine'
  | 'PolyurethaneOperator';
const polyurethaneFullAccess: PolyurethaneRoles[] = [
  'PolyurethaneAdmin',
  'PolyurethaneChief',
  'PolyurethaneViewer',
];
const accessToAllPolNR = [
  'Chief',
  'Admin',
  'Viewer',
  ...polyurethaneFullAccess,
];
export const polyurethaneAccionesRoles = {
  sharedActions: {
    scheduler: [...accessToAll, 'PolyurethaneOperator', 'PolyurethaneLeader'],
    validation: [
      ...accessToAll,
      'PolyurethaneLeader',
      'QualityControl',
      'QualityControlInspector',
      'PolyurethaneQc',
    ],
    qualityControl: [
      ...accessToAll,
      'PolyurethaneLeader',
      'QualityControl',
      'QualityControlInspector',
      'PolyurethaneQc',
    ],
    rejectedVisualQC: [
      ...accessToAll,
      'PolyurethaneLeader ',
      'PolyurethaneSupervisor',
      'QualityControl'
    ],
    packingBox: [
      ...accessToAll,
      'LabelOperator',
      'PolyurethaneLabel',
      'PolyurethaneQc',
    ],
    qcData: [
      'Admin',
      'Chief',
      'Viewer',
      'QualityControl',
      'PolyurethaneViewer',
      'PolyurethaneLeader',
      'PolyurethaneSupervisor',
    ],
    qualityAlertsAdmin: [
      'Admin',
      'Chief',
      'PolyurethaneAdmin',
      'PolyurethaneChief',
      'QualityControl',
    ],
  },

  routerActions: {
    // No hay rutas exclusivas del Router
  },

  sideNavActions: {
    root: [
      ...accessToAllPolNR,
      'PolyurethaneSupervisor',
      'PolyurethaneOperator',
      'PolyurethaneLeader',
      'PolyurethaneQc',
      'QualityControl',
      'QualityControlInspector',
      'LabelOperator',
      'PolyurethaneLabel',
    ],
    reportsPbiPolyurethane: [
      ...accessToAllPolNR,
      'PolyurethaneSupervisor',
      'PolyurethaneOperator',
      'PolyurethaneLeader',
      'PolyurethaneQc',
      'QualityControl',
      'QualityControlInspector',
      'LabelOperator',
      'PolyurethaneLabel',
    ],
  },
};
